module.exports = __webpack_public_path__ + "static/media/job-cover-icon.140daf23.svg";